import React from 'react';
import {
    NavLink,
    Link
} from 'react-router-dom'
class JournalNew extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <main className="ll__journal">
               
                <section>
                    <div class="main-container">
                        {/* <JournalNav /> */}
                        <div class="ll__journal--dtls">
                            <span class="date">13.05.2021</span>
                            <h3 class="journal-title">We Are Hiring - Heritage Architect</h3>
                            <article>
                                <article>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex quisquam dolores omnis vel. Qui amet labore repellat iste, distinctio harum veritatis sunt eos minima nostrum doloremque perspiciatis porro unde ipsum!</p>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex quisquam dolores omnis vel. Qui amet labore repellat iste, distinctio harum veritatis sunt eos minima nostrum doloremque perspiciatis porro unde ipsum!</p>
                                </article>
                                <figure className="ar-16/10">
                                    <img src="https://www.lelay.co.uk/backend/wp-content/themes/lelay/settings/assets/img/content-images/253966904-04%20Lisa%20Traxler%20-%20journal%20image.jpg"/>
                                </figure>
                                <figure className="ar-16/10">
                                    <img src="https://www.lelay.co.uk/backend/wp-content/themes/lelay/settings/assets/img/content-images/1996743751-KB_1.jpg"/>
                                </figure>
                                <p>Subtitle Module </p>
                                <figure>
                                    <img src="https://www.lelay.co.uk/backend/wp-content/themes/lelay/settings/assets/img/content-images/1584631979-img20200205_03_01.jpg"/>
                                </figure>
                                <article className="h6">
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae quasi, quidem labore culpa quisquam quibusdam, voluptas nihil fugit harum aut neque iste consequatur iusto in magnam! Officiis esse vel quia.</p>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae quasi, quidem labore culpa quisquam quibusdam, voluptas nihil fugit harum aut neque iste consequatur iusto in magnam! Officiis esse vel quia.</p>
                                </article>
                                <p><q>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex quisquam dolores omnis vel. Qui amet labore repellat iste, distinctio harum veritatis sunt eos minima nostrum doloremque perspiciatis porro unde ipsum!</q></p>
                                <p>Bulllet list module</p>
                                <div className="bulletLineStyle">
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio repellendus deserunt saepe tempora maxime laboriosam veniam nisi quam illum impedit at debitis dignissimos distinctio quasi, sequi laborum molestias dolor in!</p>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio repellendus deserunt saepe tempora maxime laboriosam veniam nisi quam illum impedit at debitis dignissimos distinctio quasi, sequi laborum molestias dolor in!</p>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio repellendus deserunt saepe tempora maxime laboriosam veniam nisi quam illum impedit at debitis dignissimos distinctio quasi, sequi laborum molestias dolor in!</p>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio repellendus deserunt saepe tempora maxime laboriosam veniam nisi quam illum impedit at debitis dignissimos distinctio quasi, sequi laborum molestias dolor in!</p>
                                </div>
                                <figure>
                                    <img src="https://www.lelay.co.uk/backend/wp-content/themes/lelay/settings/assets/img/content-images/2021275466-IMG_4450.jpg"/>
                                </figure>
                            </article>
                        </div>
                    </div>
                </section>
            </main>
        );
    }
}

export default JournalNew;


// WEBPACK FOOTER //
// ./src/components/Journals/JournalNew.js